var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6048 14.073L11.184 1.20707C10.7201 0.402111 10.1099 0 9.49825 0C8.88659 0 8.27642 0.401369 7.81249 1.20631L0.401378 14.073C-0.535405 15.6829 0.224711 17 2.08714 17H16.9094C18.7718 17 19.532 15.6829 18.6048 14.073ZM8.5333 6.48648L10.4655 6.48722V10.9884H8.53102V6.48722L8.5333 6.48648ZM9.50051 13.9073V13.908C9.07221 13.908 8.6862 13.6493 8.52217 13.2532C8.35814 12.857 8.44868 12.4014 8.75153 12.0981C9.0544 11.7956 9.50942 11.705 9.90506 11.8685C10.3007 12.0327 10.5583 12.4192 10.5583 12.8481C10.559 13.1298 10.4477 13.3996 10.2487 13.5988C10.0498 13.798 9.77961 13.9102 9.49829 13.9095L9.50051 13.9073Z",
    fill: "#EE465A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.522a85a4043bdb8186da379b5e78f934.svg";
export { ForwardRef as ReactComponent };